import React from 'react';
import CustomButton from '../viewEventUi/CustomButton';
import TermsContainer from './TermsContainer';
// import logolarge from '../../assets/logo_trans.png';
import { togetherLogo } from '../../constants';
import CardMedia from '@material-ui/core/CardMedia';
import Hidden from '@material-ui/core/Hidden';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

function LoginCard({
  card,
  imgGrid,
  imageCls,
  title,
  form,
  inputField,
  usernameHelptext,
  usernameError,
  usernameValue,
  handleEnter,
  onChangeUser,
  frgtPswd,
  passwordHelptext,
  passwordError,
  passwordValue,
  termsContainer,
  policyLink,
  termsText,
  signinBtn,
  login_fun,
  optionalContainer,
  captionText,
  registerBtn,
  onClickRegister,
  formGridCont,
  tagLine,
}) {
  return (
    <Paper elevation={10} className={card}>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
      >
        <Hidden smDown>
          <Grid
            item
            container
            xs={5}
            direction='column'
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            className={imgGrid}
          >
            <CardMedia
              component='img'
              alt='2gathers'
              image={togetherLogo.logo}
              title='2gathers'
              className={imageCls}
            />
            <Typography variant='h5' component='span' className={tagLine}>
              Celebrating Life Together
            </Typography>
          </Grid>
        </Hidden>
        <Grid
          item
          container
          md={7}
          justify='center'
          direction='column'
          alignItems='center'
          className={formGridCont}
        >
          <div className={title}>
            <Typography
              variant='h5'
              align='center'
              style={{
                fontWeight: '550',
                color: 'rgb(110, 110, 110)',
                marginBottom: '20px',
              }}
            >
              SIGN IN
            </Typography>
          </div>
          <form className={form} noValidate>
            <TextField
              FormHelperTextProps={{ margin: 'none' }}
              id='username'
              name='username'
              label='Email Address'
              placeholder='Enter your email'
              fullWidth
              type='text'
              className={inputField}
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <PersonOutlineIcon style={{ color: '#9e9e9e' }} />
                  </InputAdornment>
                ),
                style: {
                  color: '#000', //color of actual input //9999a2 --old
                },
                autoComplete: 'off',
              }}
              helperText={usernameHelptext}
              error={usernameError}
              value={usernameValue}
              onKeyDown={handleEnter}
              onChange={onChangeUser}
              InputLabelProps={{
                style: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  width: '100%',
                  color: '#000',
                },
              }}
              autoComplete='off'
              style={{ width: 'auto', minWidth: '100%' }}
            />
            <TextField
              FormHelperTextProps={{ margin: 'none' }}
              id='password'
              name='password'
              label='Password'
              placeholder='Enter password'
              fullWidth
              type='password'
              className={inputField}
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <LockOutlinedIcon style={{ color: '#9e9e9e' }} />
                  </InputAdornment>
                ),
                style: {
                  color: '#000', //color of actual input //9999a2 --
                },
              }}
              helperText={passwordHelptext}
              error={passwordError}
              value={passwordValue}
              onKeyDown={handleEnter}
              onChange={onChangeUser}
              InputLabelProps={{
                style: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  width: '100%',
                  color: '#000',
                },
              }}
              autoComplete='new-off'
            />
            <Typography
              component='a'
              gutterBottom
              href='/forgotpassword'
              variant='caption'
              className={frgtPswd}
            >
              Forgot Password?
            </Typography>
            <TermsContainer
              termsContainer={termsContainer}
              policyLink={policyLink}
              termsText={termsText}
            />

            <CustomButton
              btnStyle={signinBtn}
              clickHandle={login_fun}
              btnText={'Sign In'}
            />
          </form>

          <div className={optionalContainer}>
            <Typography
              variant='caption'
              align='center'
              className={captionText}
            >
              Create Account?
            </Typography>

            <CustomButton
              btnStyle={registerBtn}
              clickHandle={onClickRegister}
              btnText={'Sign up free'}
            />
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default LoginCard;
